import { CircularProgress as MaterialCircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMaterialCircularProgress = styled(MaterialCircularProgress)`
  color: var(--accent);
`;
